import Icon, { IconProps } from './Icon';

import PPTIcon from '../../../assets/icons/ppt.svg?react';

const PPT: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <PPTIcon />
        </Icon>
    );
};

export default PPT;

